/* eslint-disable no-param-reassign */
import { FETCH_STATUSES } from '../../../utils/fetchStatusUtils';

export default function deleteResourceSlice(options) {
  const { resource, repository } = options;

  return {
    initialState: {
      [resource]: {
        deletingStatus: FETCH_STATUSES.idle,
        errors: null,
      },
    },
    reducers: {
      deleteResourceStart(state) {
        state[resource].deletingStatus = FETCH_STATUSES.pending;
        state[resource].errors = null;
      },
      deleteResourceSuccess(state) {
        state[resource].deletingStatus = FETCH_STATUSES.fulfilled;
      },
      deleteResourceFail(state, { payload: { errors } }) {
        state[resource].deletingStatus = FETCH_STATUSES.failed;
        state[resource].errors = errors;
      },
      deleteResourceReset(state) {
        state[resource].deletingStatus = FETCH_STATUSES.idle;
        state[resource].errors = null;
      },
    },
    actionCreators(restDispatch) {
      return {
        deleteResource: async (...params) => {
          try {
            restDispatch('deleteResourceStart');
            await repository.delete(...params);
            restDispatch('deleteResourceSuccess');
          } catch (errors) {
            const { response } = errors;
            const { data } = response;
            restDispatch('deleteResourceFail', data);
            throw errors;
          }
        },
        deleteResetResource: () => restDispatch('deleteResourceReset'),
      };
    },
    abstractSelector: (state) => {
      return {
        resource: state[resource],
      };
    },
  };
}
